<template>
  <Section
    :id="id"
    :aria-label="t('shipments.specialInstructions')"
    data-class="flex flex-column flex-gap-1"
  >
    <KeyValuePair
      :value="carrierNotes"
      :label="t('orders.paramNotes', { param: t('carriers.carriers') })"
      uppercase-label
    />
  </Section>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  carrierNotes: {
    type: String,
    default: () => '',
  },
});
const { id, carrierNotes } = toRefs(props);

const { t } = useI18n();
</script>
